export const API_URL = process.env.REACT_APP_API_URL || 'https://api.fleetservices.pro';
export const API_BASE = `${API_URL}/api`;
